import { withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05525346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "fScreen" }
const _hoisted_2 = {
  class: "ymap-search-bar",
  style: {"position":"absolute","top":"164px","z-index":"1"}
}
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21.914\" height=\"21.914\" viewBox=\"0 0 21.914 21.914\" data-v-05525346><g id=\"Group\" data-name=\"Group\" transform=\"translate(-1102 -279)\" data-v-05525346><g id=\"Circle\" data-name=\"Circle\" transform=\"translate(1102 279)\" fill=\"none\" stroke=\"#000\" stroke-width=\"2\" data-v-05525346><circle cx=\"7.5\" cy=\"7.5\" r=\"7.5\" stroke=\"none\" data-v-05525346></circle><circle cx=\"7.5\" cy=\"7.5\" r=\"6.5\" fill=\"none\" data-v-05525346></circle></g><line id=\"Line\" data-name=\"Line\" x1=\"8\" y1=\"8\" transform=\"translate(1114.5 291.5)\" fill=\"none\" stroke=\"#000\" stroke-linecap=\"round\" stroke-width=\"2\" data-v-05525346></line></g></svg>", 1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "map" }, null, -1))
const _hoisted_7 = {
  class: "ymap-select-place",
  style: {"position":"absolute","top":"601px","z-index":"1"}
}
const _hoisted_8 = { style: {"margin-top":"-524px","margin-left":"525px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-title" }, "Сохранённая для дизайн-проекта карта", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  ref: "sScreen",
  style: {"display":"none"},
  class: "save-screen"
}
const _hoisted_12 = { class: "edit-canvas" }
const _hoisted_13 = { class: "edit-tools" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "editCanvas",
  width: "450",
  height: "450"
}, null, -1))
const _hoisted_15 = { class: "ymap-save" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","margin-top":"-24px"} }, [
  /*#__PURE__*/_createElementVNode("p", { class: "small-title" }, "Предпросмотр"),
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "mapCanvas",
    width: "900",
    height: "450"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "embeddedCanvas",
  style: {"display":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          ref: "searchBar",
          onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.SearchBarHandler && _ctx.SearchBarHandler(...args)), ["enter"])),
          type: "text",
          id: "search",
          class: "ymap-search-bar__input",
          placeholder: "Найти на карте",
          value: _ctx.address_line
        }, null, 40, _hoisted_3),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SearchBarHandler && _ctx.SearchBarHandler(...args))),
          type: "button",
          class: "ymap-search-bar__button"
        }, _hoisted_5)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SelectPlace && _ctx.SelectPlace(...args))),
          class: _normalizeClass(["ymap-select-place__button ymap_common-button", { active_btn: _ctx.reactive_vars.open_menu }]),
          style: {"margin-left":"0px"}
        }, " Указать место ", 2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("img", {
          src: 
          'https://api.rekprof.ru/files/' +
          _ctx.document.map_yandex_file +
          '?a=' +
          _ctx.map_random
        ,
          style: {"width":"1000px","height":"auto","box-shadow":"0 3px 6px #00000026","border-radius":"5px"}
        }, null, 8, _hoisted_10)
      ])
    ], 512),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.SetDrawingMode(0))),
            class: "edit-tools__button edit-tools__button-draw"
          }),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.SetDrawingMode(1))),
            class: "edit-tools__button edit-tools__button-line"
          }),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.DrawMap())),
            class: "edit-tools__button edit-tools__button-reset"
          })
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.GoBack && _ctx.GoBack(...args))),
          class: "ymap_common-button active_btn",
          style: {"position":"absolute","top":"619px"}
        }, " Вернуться "),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.SaveAndUploadMapImages())),
          class: "ymap-save__button ymap_common-button active_btn",
          style: {"margin-left":"170px","position":"absolute","top":"619px"}
        }, " Сохранить ")
      ]),
      _hoisted_16
    ], 512),
    _hoisted_17
  ], 64))
}